import { ISubjectNameResponse, ISubjectResponse } from '../models';
import { $api } from '../service';

export const getSubjects = async () => {
  const { data } = await $api.get<ISubjectResponse>('/subjecttest');

  return { subjects: data };
};

export const getSubjectsName = async () => {
  const { data } = await $api.get<ISubjectNameResponse>('/subjectname');

  return { subjectsName: data };
};
